import template from './solidarityRouting.html';
import controller from './solidarityRouting.controller';
import './solidarityRouting.scss';

let solidarityRoutingComponent = {
  restrict: 'E',
  bindings: {
    moduleClosed: '<',
  },
  template,
  controller,
};

export default solidarityRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/solidarityRouting/solidarityRouting.component.js